import { useMutation, useQueryClient } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { CreateProfileRequestDto, CreateProfileResponseDto } from "../types/dto";

import { contactsSearchProfilesQueryKeys } from "./queryKeyFactory";

export const useCreateContactProfileMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<CreateProfileResponseDto, Error, CreateProfileRequestDto>({
        mutationFn: (payload) => salesApiService.contactsSearchProfiles.createProfile(payload),
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: contactsSearchProfilesQueryKeys.allProfiles() });
        },
    });
};
